import React from 'react';
import { connect } from 'react-redux';
import { trainerFormsPath } from 'config/paths';
import { withTranslation } from 'react-i18next';
import withTrainer from 'partials/TrainerLoader';
import { assignSchedulables, loadSchedulableSettings } from 'redux/actions';
import { formRecordsByIdsSel } from 'redux/selectors';
import { AssignRecords } from './AssignRecords';

class AssignForms extends React.Component {

    render() {
        const { t } = this.props;

         return (
            <AssignRecords 
                {...this.props}
                title={t('assign fcas')}
                formProps={{
                    recordName: 'form', 
                    createRecordsPath: trainerFormsPath, 
                    createRecordsTip: t('create forms tip'), 
                    createRecordsBtnLabel: t("Go to Forms Activity"),
                    recordsByIdsSel: formRecordsByIdsSel
                }}
            />
        )
    }
}

export const mapDispatchToProps = dispatch => ({
    loadSettings: (data) => dispatch(loadSchedulableSettings({ recordType: 'Form', ...data })),
    assignSettings: data => dispatch(assignSchedulables({ recordType: 'Form', ...data }))
})

export default connect(null,mapDispatchToProps)(withTranslation()(withTrainer(false)(AssignForms)))